import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OnlineIndicatorComponent } from "../online-indicator/online-indicator.component";

@Component({
  selector: "app-header-component",
  standalone: true,
  imports: [CommonModule, OnlineIndicatorComponent],
  templateUrl: "./header-component.component.html",
  styleUrl: "./header-component.component.scss"
})
export class HeaderComponentComponent {
  @Input() showSearchOptions = false;
}
